import state from "./moduleMailFolderStates";
import mutations from "./moduleMailFolderMutations";
import actions from "./moduleMailFolderActions";
import getters from "./moduleMailFolderGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}